import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * AdminRoute component that protects routes that should only be accessible by admin users
 * Redirects to admin login if user is not authenticated or not an admin
 */
const AdminRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);
  
  useEffect(() => {
    // Check if we have admin data in localStorage
    const storedUser = localStorage.getItem('user');
    const userType = localStorage.getItem('userType');
    const token = localStorage.getItem('token');
    
    // If we have a token and userType is admin, we're good to go
    if (token && userType === 'admin' && storedUser) {
      setIsChecking(false);
    } else {
      setIsChecking(false);
    }
  }, []);
  
  // While checking auth state, return nothing to prevent flash of login page
  if (isChecking) {
    return null;
  }
  
  // Check if user is logged in and has admin role
  // First check localStorage in case the context hasn't updated yet
  const userType = localStorage.getItem('userType');
  const token = localStorage.getItem('token');
  const isAdmin = (user && user.role === 'admin') || userType === 'admin';
  
  // If no token or not admin, redirect to admin login
  if (!token || !isAdmin) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  
  // If user is admin, render the children or outlet
  return children || <Outlet />;
};

export default AdminRoute;
